import React from "react";
import { Box } from "@mui/material";

import Panel from "../../../../components/Panel";
import { HmisSettings } from "./HmisSettings";
import SettingsButton from "../../../../components/SettingsButton/SettingsButton";

interface Props {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  renderSettingButton?: boolean;
}

// eslint-disable-next-line import/prefer-default-export
export const HmisSettingsPanel = ({
  open,
  onOpenChange,
  renderSettingButton = true
}: Props): React.ReactNode => {
  const [internalOpen, setInternalOpen] = React.useState(false);

  const isControlled = typeof open === "boolean";
  const actualOpen = isControlled ? open : internalOpen;

  const setOpen = (value: boolean): void => {
    if (isControlled) {
      onOpenChange?.(value);
    } else {
      setInternalOpen(value);
    }
  };

  return (
    <>
      {renderSettingButton && <SettingsButton onClick={() => setOpen(!actualOpen)} />}

      {actualOpen && (
        <Panel onClose={() => setOpen(false)} title="HMIS Settings">
          <Box>
            <HmisSettings />
          </Box>
        </Panel>
      )}
    </>
  );
};
